module.exports = __webpack_public_path__ + "img/Draw.63eb4519.png";